import type { ReactElement } from "react";
import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";

import clearPhoneNumber from "../../../helpers/clearPhoneNumber";
import type { ContactSearchEntry } from "../../../types/common";
import { ContactEntryType } from "../../../types/common";
import getContactPrivateData from "../../../utils/getContactPrivateData";

interface IProps {
    rowData: ContactSearchEntry;
    onClick?: () => void;
}

const WhatsappLinkButton = ({ rowData, onClick }: IProps): ReactElement => {
    const whatsappLink: string | null = useMemo(() => {
        if (!rowData.isRevealed) {
            return null;
        }

        const privateData = getContactPrivateData(rowData);

        const mobilePhoneNumber = (privateData?.phoneNumbers || []).find(
            (phone) => phone.internalType === ContactEntryType.Mobile,
        );

        if (!mobilePhoneNumber) {
            return null;
        }

        return `https://wa.me/${clearPhoneNumber(mobilePhoneNumber.number)}`;
    }, [rowData]);

    const isWhatsappDisabled = !rowData.isRevealed || whatsappLink === null;
    const tooltipText = translate(
        `si.contacts_search.action.send-whatsapp.${!rowData.isRevealed ? "disabled-tooltip" : "empty-number.tooltip"}`,
    );

    const buttonElement = (
        <ExportVariantsDropdownItem
            iconName="whatsapp"
            isUseLockedIcon={false}
            text={translate("si.contacts_search.action.send-whatsapp.title")}
            isDisabled={isWhatsappDisabled}
            tooltipDisabledContent={isWhatsappDisabled ? tooltipText : undefined}
            variant="whatsapp"
            onClick={onClick}
        />
    );

    return !isWhatsappDisabled ? (
        <a
            href={whatsappLink}
            target="_blank"
        >
            {buttonElement}
        </a>
    ) : (
        buttonElement
    );
};

export default WhatsappLinkButton;
